'use es6';

import { Record } from 'immutable';
import AllObjectPropertiesReferenceResolver from 'reference-resolvers/resolvers/AllObjectPropertiesReferenceResolver';

// Any fields that values are another record type need to be updated in customer-data-objects/property/PropertyNameToReferenceType

const ObjectDefinitionRecord = Record({
  /** A boolean that determines if the object will be able to be used in association filters for objects with defined associations to the object. */
  enableAsAssociatedType: false,
  /**
   * An optional function that returns true if the user has access to the object definition, otherwise returns false.
   * @param {function} isUngated - Takes in the name of a gate. Returns true if the user is ungated, otherwise returns false.
   * @param {function} hasScope - Takes in the name of a scope. Returns true if the user has the scope, otherwise returns false.
   */
  hasAccess: () => true,
  /** A string that is the object type id, should be defined in 'customer-data-objects/constants/ObjectTypeIds'. */
  objectTypeId: '',
  /**
   * An optional function that returns a resolver for fetching properties of this object type.
   * By default, the provider will make a resolver using the objectTypeId and AllObjectPropertiesReferenceResolver.
   * If supplying your own resolver, it should be defined in 'reference-resolvers/resolvers/'.
   */
  getPropertyResolver() {
    return AllObjectPropertiesReferenceResolver(this.objectTypeId);
  },
  /** A string that is the reference type, it should be in upper case snake case and end in '_PROPERTIES'. */
  referenceObjectType: ''
}, 'ObjectDefinition');
export default ObjectDefinitionRecord;